export const sendOlbKeepAlive = () => {
  const getIsInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true; // Assume iframe if access is denied
    }
  };

  const isInIframe = getIsInIframe();

  if (isInIframe) {
    // Post message to parent iframe
    window.parent.postMessage({ type: "OLB_KEEP_ALIVE" }, "*");
  } else if (window.ReactNativeWebView) {
    // Post message to React Native WebView
    window.ReactNativeWebView.postMessage("OLB_KEEP_ALIVE");
  }
};



// WEBPACK FOOTER //
// ./src/utils/sendOlbKeepAlive.js